module.exports = __webpack_public_path__ + "img/tokens.b9ccce7e.png";